import { formatEuro } from '../../util/payment';
import { participantGroupColor } from './chartColors';

// Donut "Gruppen & Rollen" (event and year view): the role part comes from the breakdown
// (Spieltagleiter = role + leading, Orga = role + playing), the rest is split by snapshot group
// (participantGroups: present players without role, paid income).
export function buildAttendanceSegments(breakdown, participantGroups, colors) {
  const roles = [
    { key: 'role-lead', name: 'Spieltagleiter', value: breakdown?.orga ?? 0,       color: colors.negative },
    { key: 'role-orga', name: 'Orga',           value: breakdown?.orgaPlayer ?? 0, color: colors.warning },
  ];

  const groups = (participantGroups ?? []).map(g => ({
    key: `group-${g.participantGroupId}`,
    name: g.name,
    value: g.count ?? 0,
    incomeCents: g.incomeCents ?? 0,
    color: participantGroupColor(colors, g.colorKey),
    isGroup: true,
  }));

  return [...roles, ...groups].filter(s => s.value > 0);
}

// Tooltip value per segment: "20 Spieler · 400,00 €" for groups (decision 11: income per group),
// "3 Spieler" for the role segments.
export function formatAttendanceValue(value, _name, segment) {
  const people = `${value} Spieler`;
  return segment?.isGroup ? `${people} · ${formatEuro((segment.incomeCents ?? 0) / 100)}` : people;
}
